import { useTranslations, Language } from '@/hooks/useTranslations';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

// Flag emoji components for better rendering
const flags: Record<string, string> = {
  de: '🇩🇪',
  en: '🇬🇧',
};

const LanguageSwitcher = () => {
  const { language, setLanguage, availableLanguages } = useTranslations();

  const currentLang = availableLanguages.find((l) => l.code === language);
  const triggerLabel = language === 'en'
    ? `Change language. Current language: ${currentLang?.name ?? 'English'}`
    : `Sprache ändern. Aktuelle Sprache: ${currentLang?.name ?? 'Deutsch'}`;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="px-3"
          aria-label={triggerLabel}
        >
          {language === 'en' ? 'Language' : 'Sprache'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-card border border-border z-50"
        aria-label={language === 'en' ? 'Available languages' : 'Verfügbare Sprachen'}
      >
        {availableLanguages.map((lang) => {
          const isActive = language === lang.code;
          return (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => setLanguage(lang.code as Language)}
              aria-current={isActive ? 'true' : undefined}
              lang={lang.code}
              className={`gap-2 cursor-pointer ${isActive ? 'bg-muted text-foreground font-medium' : 'text-foreground'}`}
            >
              <span className="text-typography-body leading-none" aria-hidden="true">{flags[lang.code]}</span>
              <span className="text-typography-body">{lang.name}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
